import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Select,
  Image,
  Table,
  Input,
  Modal,
  notification,
} from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { GreenNotify, RedNotify } from "../../helper/helper";
import AddFaceYoga from "../../components/updateFaceYoga/updateFaceYoga";
import { homeIcon } from "../../assets";

const Organizers = () => {
  const [yogas, setYogas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedYoga, setSelectedYoga] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [updateRecordData, setUpdateRecordData] = useState(null);
  const [isAddYogaModalVisible, setIsAddYogaModalVisible] = useState(false);
  const [expandedDescription, setExpandedDescription] = useState(null);

  const getAllYogas = () => {
    callApi("GET", routes.getYogas, null, setIsLoading, (res) => {
      console.log("resp", res);
      setYogas(res?.data?.faceYogas || []);
    });
  };

  useEffect(() => {
    getAllYogas();
  }, []);
  const showFullDescription = (text) => {
    Modal.info({
      title: "Description",
      content: (
        <div>
          <p style={{ textAlign: "justify" }}>{text}</p>
        </div>
      ),
      onOk() {},
    });
  };
  const handleDelete = (recordId) => {
    callApi(
      "DELETE",
      `${routes.deleteFaceYoga}/${recordId}`,
      null,
      setIsLoading,
      (res) => {
        if (res.status === 200) {
          setYogas((prevYogas) =>
            prevYogas.filter((yoga) => yoga._id !== recordId)
          );
          GreenNotify("FaceYoga Deleted Successfully");
        } else {
          RedNotify("Error Occurred while deleting stage");
        }
      },
      (error) => {
        notification.error({
          message: "Error",
          description: "An error occurred while deleting the stage.",
        });
      }
    );
  };

  const handleAddYoga = () => {
    setUpdateRecordData(null);
    setIsAddYogaModalVisible(true);
  };

  const handleEditYoga = (recordId) => {
    const selectedYoga = yogas.find((yoga) => yoga._id === recordId);
    setUpdateRecordData(selectedYoga);
    setIsAddYogaModalVisible(true);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Content",
      dataIndex: "content",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div>
          {expandedDescription === record.key ? (
            <span>{text}</span>
          ) : (
            <div>
              <span>{`${text?.slice(0, 50)}...`}</span>
              <Button type="link" onClick={() => showFullDescription(text)}>
                See More
              </Button>
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Exercises",
      dataIndex: "exercises",
      align: "center",
    },
    {
      title: "Category",
      dataIndex: "category",
      align: "center",
    },
    {
      title: "Sub_Category",
      dataIndex: "sub_category",
      align: "center",
    },
    {
      title: "Image",
      dataIndex: "image",
      align: "center",
      render: (image) => (
        <div className="product-list-image">
          <Image
            style={{
              width: 100,
              height: 100,
              borderRadius: 50,
              objectFit: "cover",
            }}
            src={image}
            alt="yoga-image"
          />
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "_id",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEditYoga(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
        </div>
      ),
      width: "auto",
    },
  ];

  const data = yogas
    .map((item, index) => {
      const mappedItem = {
        key: index,
        _id: item._id,
        title: item.title,
        content: item?.content,
        exercises: item.exercises,
        image: item?.image,
        category: item?.category?.lang?.en?.title,
        sub_category: item.sub_category?.lang?.en?.title,
      };
      console.log(mappedItem);
      return mappedItem;
    })
    .filter((item) =>
      item?.title?.toLowerCase().includes(searchText.toLowerCase())
    );

  const getRowClassName = (record, index) =>
    index % 2 === 0 ? "server-role-even-row" : "server-role-odd-row";

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isLoading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>FaceYogas</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>FaceYogas</h1>
        <div></div>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAddYoga}
        style={{ marginBottom: "16px" }}
      >
        Add Yoga
      </Button>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={true}
          className="subscriptionapi-table"
        />
      </div>

      <AddFaceYoga
        visible={isAddYogaModalVisible}
        toggleModal={() => {
          setIsAddYogaModalVisible(false);
          getAllYogas();
        }}
        recordData={updateRecordData}
      />
    </div>
  );
};

export default Organizers;
